module.exports = __webpack_public_path__ + "img/30.6e00c92e.jpg";